
<template>
  <v-dialog v-model="dialog" transition="dialog-bottom-transition" scrollable>
    <template v-slot:activator="{ props }">
      <v-btn color="primary" :class="{ 'float-right': floatRight }" v-bind="props"><v-icon class="mr-2">mdi-plus</v-icon>
        Novo Grupo/Tropa</v-btn>
    </template>
    <v-card>
      <v-toolbar color="primary"
                 :title="subGroup.id ? `${subGroup.name} (editar grupo/tropa)` : 'Novo Grupo/Tropa'">
        <v-btn color="black" @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text>
        <FormSubGroup :user="user"
                      :subGroup="subGroup"
                      @created="createdObject"
                      @updated="updatedObject" />
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn variant="text" color="error" @click="dialog = false">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

import FormSubGroup from './FormSubGroup.vue';

export default {
  components: { FormSubGroup },
  props: {
    user: Object,
    floatRight: Boolean,
    subGroup: Object,
    dialogStatus: Boolean,
  },
  data() {
    return {
      dialog: false,
    };
  },
  emits: ['closed', 'created', 'updated'],
  mounted() { },
  activated() { },
  methods: {
    createdObject(object) {
      this.dialog = false;
      this.$emit('created', object)
    },
    updatedObject(object) {
      this.$emit('updated', object)
    }
  },
  computed: {},
  watch: {
    dialog(newVal) {
      if (!newVal) {
        this.$emit('closed')
      }
    },
    dialogStatus(newVal) {
      if (newVal) {
        this.dialog = true
      }
    }
  }
};
</script>
